/// <reference path="../../services/session.service.ts" />
/// <reference path="../../services/navigation.service.ts" />
/// <reference path="../interfaces/istepcontroller.ts" />
/// <reference path="../../services/validation.service.ts" />
/// <reference path="../../objects/classes/User.ts"/>
/// <reference path="../../services/account.service.ts"/>

module App.Controllers {
    import User = Classes.User

    export interface IBaseController {
        nextStep(): void
        previousStep(): void
        goToStep(name: string): void
        goToOperation(name: string): void
    }

    export class BaseController implements IBaseController {
        constructor(public $rootScope: Interfaces.IAppRootScope,
            public $scope: any,
            private $q: ng.IQService,
            public sessionService: App.Interfaces.ISessionService,
            public navigationService: App.Interfaces.INavigationService,
            protected compositionService: App.Interfaces.ICompositionService,
            protected ngDialog: any,
            protected $sce: any,
            protected validationService: App.Interfaces.IValidationService,
            protected accountService: App.Interfaces.IAccountService,
            public snackbarFactory: Interfaces.ISnackbarFactory)
        {
            this.accountService.getUser().then(user => {
                this.user = user
            })

            this.sessionService.currentStep = this.navigationService.currentStep().name
            $scope.$state = this.navigationService.currentStep()

            $rootScope.isPageValid = false

            if (this.navigationService.currentStep().order > this.sessionService.maxStepNumber) {
                this.sessionService.maxStepNumber = this.navigationService.currentStep().order
            }

            $rootScope.$emit('$locationChangeStart', this.sessionService.currentStep)

            var unregisterFn = $rootScope.$on(Constants.broadcast.validateStep, (event, stepName, current) => {
                if (this.instanceOfIStepController(this)) {
                    var currentController = (<Interfaces.IStepController>this)
                    var currentStepName = (<Interfaces.IStepController>this).stepName
                    
                    if (currentStepName == stepName) {
                        if (currentController.isValid()) {
                            this.doCompositionRequest(true)
                                .then((composition) => {
                                    this.validationService.clearLoadingTimer()
                                }).catch((err) => {
                                    this.snackbarFactory.show('Fout met opslaan', 3000)
                                    this.validationService.clearLoadingTimer()
                            })
                        } else {
                            this.validationService.clearLoadingTimer()
                        }
                    }
                }
            })

            $scope.$on('$destroy', unregisterFn)

            this.checkStep()

            this.checkPopup()

        }

        isAuthenticated = () => this.accountService.isAuthenticated

        instanceOfIStepController(data: any): data is Interfaces.IStepController {
            return 'stepName' in data
        }

        checkStep = () => {
            if (this.sessionService.maxStepNumber < this.navigationService.currentStep().order) {
                this.navigationService.goToStepNumber(this.sessionService.maxStepNumber)
            }
        }

        nextStep = () => {
            this.navigationService.nextStep()
        }

        previousStep = () => {
            this.navigationService.previousStep()
        }

        goToStep = (name: string) => {
            this.navigationService.goToStep(name)
        }

        goToStepIndex = (index: number) => {
            this.navigationService.goToStepIndex(index)
        }

        goToStepNumber = (stepNumber: number) => {
            this.navigationService.goToStepNumber(stepNumber)
        }

        goToOperation = (name: string) => {
            this.navigationService.goToOpertation(name)
        }

        getIsPageValid = () => {
            return this.$rootScope.isPageValid
        }

        checkPageValidation() {
            if (this.instanceOfIStepController(this)) {
                var currentController = (<Interfaces.IStepController>this)
                this.$rootScope.isPageValid = currentController.isValid(true)
            }
        }

        setCompositionValue = (key: string, value: any, autocontinue: boolean): ng.IPromise<App.Classes.IComposition> => {
            var deffered = this.$q.defer<App.Classes.IComposition>()

            this.compositionService.handleCompositionRequest(key, value).then((compositionResult) => {
                if (compositionResult.error) {
                    if (compositionResult.operationValue != null) {
                        deffered.reject(compositionResult.operationValue)
                    }
                    else {
                        deffered.reject('Error saving composition')
                    }

                    return
                }

                this.$scope.$emit(Constants.broadcast.compositionChange)

                if (autocontinue && compositionResult.operation != this.sessionService.currentStep) {
                    this.nextStep()
                }

                deffered.resolve(compositionResult.composition)
            }).catch((err) => {
                deffered.reject(err)
            })

            return deffered.promise
        }

        doCompositionRequest = (autocontinue: boolean): ng.IPromise<App.Classes.IComposition> => {
            var deffered = this.$q.defer<App.Classes.IComposition>()

            this.compositionService.doCompositionRequest(this.sessionService.composition).then((compositionResult) => {

                if (compositionResult.error) {
                    if (compositionResult.operationValue != null) {
                        this.snackbarFactory.show(compositionResult.operationValue.toString(), 3000)
                        return deffered.reject(compositionResult.operationValue)
                    } else {
                        this.snackbarFactory.show('Fout met opslaan', 3000)
                        return deffered.reject('Error saving composition')
                    }
                }

                this.$scope.$emit(Constants.broadcast.compositionChange)

                let currentStep = this.navigationService.getStepByStepName(this.sessionService.currentStep)
                let operationIsCurrentStep = currentStep.operations.indexOf(compositionResult.operation) >= 0
                let canGoToNextStep = autocontinue && !operationIsCurrentStep && compositionResult.operation != ''
                
                if (canGoToNextStep)
                {
                    this.nextStep()
                }

                deffered.resolve(compositionResult.composition)
            }).catch((err) => {
                deffered.reject(err)
            })

            return deffered.promise
        }

        checkPopup = () => {
            if (this.sessionService.composition != null) {
                if (this.sessionService.composition.showInfoPopup && this.navigationService.currentStep().name == this.sessionService.composition.infoPopupStepName) {
                    this.$scope.value = this.$sce.trustAsHtml(this.sessionService.composition.infoPopupContent)
                    this.ngDialog.open({
                        template: 'popupTmpl.html',
                        className: 'ngdialog-theme-default',
                        scope: this.$scope
                    })
                }
            }
        }

        user: User

        login = () => {
            this.accountService.login()
        }

        logout = () => {
            this.accountService.logout()
        }

        brandNotSupported = () => {
            if (this.sessionService.composition != null) {
                return this.sessionService.composition.alternativeUrl != null
            }
            return false
        }

        submenuActive: boolean
        submenuClicked: boolean

        showSubmenu = () => {
            if (!this.submenuClicked)
                this.submenuActive = true
        }

        hideSubmenu = () => {
            if (!this.submenuClicked)
                this.submenuActive = false
        }

        toggleSubmenu = () => {
            this.submenuClicked = !this.submenuClicked
            this.submenuActive = this.submenuClicked
        }

    }
} 